import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { CommonService } from '@app/service/common.service';
import { UtilService } from '@app/service/util.service';

import { Globals } from '@app/service/globals.service';
import { ToastrService } from 'ngx-toastr';
import { CustomValidator } from '@app/service/custom.validators';

import { HMemberService } from '@home/service/member.service';
import { BoardService } from '@app/home/service/board.service';

@Component({
  selector: 'app-board-reply',
  templateUrl: './board-reply.component.html',
  styleUrls: ['./board-reply.component.scss']
})
export class BoardReplyComponent implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public form: FormGroup;
  public formErrors = {};

  public params: any = {
    type: '',     // 리스트, 내용보기, 쓰기, 수정 : list, view, write, modify
    board_seq: 0,  // 게시판 순번
    no: 1,        // 현재 페이지
    row: 10,      // 페이지당 보여줄 갯수
  };

  public data: any = [];
  public group: any = [];
  public boardInfo: any = {};

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,

    private formBuilder: FormBuilder,
    private utilService: UtilService,
    private toastrService: ToastrService,
    private globals: Globals,

    private memberService: HMemberService,
    private boardService: BoardService,
  ) {
    this.buildForm();
  }

  /*******************************************************************************
    설  명 : 폼생성
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  buildForm(): void {
    this.form = this.formBuilder.group({
      board_index: ['', [Validators.required] ],
      board_seq: ['', []],
      board_id: ['', [Validators.required, Validators.maxLength(50)] ],
      group_id: ['', [Validators.maxLength(255)] ],
      subject: ['', [Validators.required, Validators.maxLength(255)] ],
      contents: ['', [Validators.required] ],
      is_pw: [false, [Validators.maxLength(255)]],
      pw: ['', [Validators.maxLength(50)] ],
      email: ['', [Validators.email, Validators.maxLength(255)] ],
      notice_sdate: ['', [] ],
      notice_edate: ['', [] ],
      send_yn: [false, [] ],
      screen_x: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      screen_y: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      layer_popup: [false, [] ],
      popup_width: ['500', [Validators.maxLength(4), CustomValidator.numeric] ],
      popup_height: ['700', [Validators.maxLength(4), CustomValidator.numeric] ],
      popup_yn: [false, [] ],
      is_notice: [false, [] ],
      is_titlelink: [false, [] ],
      title_link: ['', [Validators.maxLength(1000)] ],
      file: ['', [] ],
      upload: [ [], [] ],
      files: [ [], [] ],
      tag: ['', [] ],
      product_category1: ['', [] ],
      product_category2: ['', [] ],
      company_seq: ['', [] ],
      schedule_date: ['', [] ],
      recruitment_period_sdate: ['', [] ],
      recruitment_period_edate: ['', [] ],
      company_name: ['', [] ],
      recruitment_number: ['', [] ],
      salary_seq: ['', [] ],
      charge: ['', [] ],
      recuritment_part_seq: ['', [] ],
      academic_ability_seq: ['', [] ],
      career_seq: ['', [] ],
      tel: ['', [] ],
      fax: ['', [] ],
      contact_email: ['', [] ],
      website: ['', [] ],
      zipcode: ['', [] ],
      address: ['', [] ],
      address_detail: ['', [] ],
      speciality: ['', [] ],
      name: ['', [] ],
      birthday: ['', [] ],
      is_solar: ['', [] ],
      circulation_seq: ['', [] ],
      hp: ['', [] ],
      department: ['', [] ],
      position: ['', [] ],
      mem_no: ['', [] ],

      tel1: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      tel2: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      tel3: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      fax1: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      fax2: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      fax3: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      hp1: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      hp2: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      hp3: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
    });

    this.form.valueChanges.subscribe(data => {
      this.utilService.updateFormErrors( this.form, this.formErrors );
    });
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.params.board_id = ( typeof params.board_id == 'undefined' || params.board_id == '' ) ? 'notice' : params.board_id;
      this.params.type = ( typeof params.type === 'undefined' || params.type === '' ) ? 'list' : params.type;
      this.params.no = ( typeof params.no === 'undefined' || params.no === '' ) ? '1' : params.no;
      this.params.board_seq = ( typeof params.board_seq === 'undefined' || params.board_seq === '' ) ? '0' : params.board_seq;

      this.getBoardView( this.params );
    });
  }

  /*******************************************************************************
    설  명 : 게시글 내용 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardView( params ) {
    this.boardService.getBoardView( params.board_id, params.board_seq, true ).then( response => {
      if( response.ResultCode ) {
        let tmp = {
          detail: response.data,
          upload: response.upload
        };
        this.data = tmp;
        this.form.patchValue( response.data );
        this.form.patchValue( {subject: '', contents: ''});
        this.globals.indicator.next(false);
      } else {
        this.globals.indicator.next(false);
        this.toastrService.error( response.ResultMessage, "게시글 에러" );

        this.router.navigate( ['/main'] );
        return false;
      }
    }, error => {
      this.globals.indicator.next(false);
      console.log( error );

      this.toastrService.error( "존재하지 않는 게시글입니다.", "게시글 에러" );
    });
  }

  /*******************************************************************************
    설  명 : 게시판 답변쓰기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  write() {
    this.utilService.makeFormDirtyAndUpdateErrors(this.form, this.formErrors);
    if ( this.form.valid ) {
      this.boardService.setReply( this.form ).then( response => {
        if ( response.ResultCode ) {
          this.toastrService.success( response.ResultMessage, '답변하기');

          this.list();
        } else {
          this.toastrService.error( response.ResultMessage, '답변하기');
        }
      });
    } else {
      this.toastrService.error('필수 입력항목을 확인하시기 바랍니다.');
    }
  }

  /*******************************************************************************
    설  명 : 목록으로
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  list() {
    this.params.type = 'list';
    this.router.navigate(
      [location.pathname],
      {
        relativeTo: this.activatedRoute,
        queryParams: this.params,
        queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

}
